import axios from 'axios';
import { HOMEPAGEURL } from '../index';

export const getHomepageApi = (postData) => {
  return axios.post(HOMEPAGEURL, JSON.stringify(postData));
};
